import { Component, ElementRef, ViewChild } from '@angular/core';
import { ToastService } from '../toast.service';
declare var bootstrap: any; // import bootstrap JS

@Component({
  selector: 'app-common-toast',
  standalone: true,
  imports: [],
  templateUrl: './common-toast.component.html',
  styleUrl: './common-toast.component.scss'
})
export class CommonToastComponent {
  @ViewChild('errorToast', { static: true }) errorToast!: ElementRef;
  toastMessage = '';
  toastType = 'danger';

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.toastService.toastMessage$.subscribe(({ message, type }) => {
      this.toastMessage = message;
      this.toastType = type || 'danger';

      const toastEl = this.errorToast.nativeElement;
      const toast = new bootstrap.Toast(toastEl);
      toast.show();
    });
  }
}
